import Keycloak from 'keycloak-js';

const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

if (!keycloakUrl || !keycloakRealm || !keycloakClientId) {
    throw new Error(`Keycloak environment variables not set: KEYCLOAK_URL=${keycloakUrl}, KEYCLOAK_REALM=${keycloakRealm}, KEYCLOAK_CLIENT_ID=${keycloakClientId}`);
}

const keycloak = new Keycloak({
    url: keycloakUrl,
    realm: keycloakRealm,
    clientId: keycloakClientId,
});

export const keycloakProviderInitConfig = {}

export default keycloak;